/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'barcode-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M23.5 3h-22A1.5 1.5 0 0 0 0 4.5v16A1.5 1.5 0 0 0 1.5 22h22a1.5 1.5 0 0 0 1.5-1.5v-16A1.5 1.5 0 0 0 23.5 3zM4 19H3V6h1zm3 0H6v-1h1zm0-2H6V6h1zm3 2H9v-1h1zm0-2H9V6h1zm3 2h-1v-1h1zm0-2h-1V6h1zm3 2h-1v-1h1zm0-2h-1V6h1zm3 2h-1v-1h1zm0-2h-1V6h1zm3 2h-1V6h1z"/>'
  }
})
